var _circle, _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPersonalDetailsWhiteBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 14.5,
    cx: 18.5,
    cy: 18.5,
    fill: "white",
    stroke: "white",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.67 21.73C21.9175 21.73 24.55 19.0974 24.55 15.85C24.55 12.6025 21.9175 9.96997 18.67 9.96997C15.4226 9.96997 12.79 12.6025 12.79 15.85C12.79 19.0974 15.4226 21.73 18.67 21.73Z",
    stroke: "#000000d9",
    strokeWidth: 2.11,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19_256",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 1,
    width: 34,
    height: 34
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.67 34.9799C27.8656 34.9799 35.32 27.5255 35.32 18.3299C35.32 9.13439 27.8656 1.67993 18.67 1.67993C9.47448 1.67993 2.02002 9.13439 2.02002 18.3299C2.02002 27.5255 9.47448 34.9799 18.67 34.9799Z",
    fill: "white",
    stroke: "#000000d9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19_256)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.63 21.73H21.71C26.91 21.73 31.14 25.95 31.14 31.16V43.62H6.20001V31.16C6.20001 25.96 10.42 21.73 15.63 21.73Z",
    stroke: "#000000d9",
    strokeWidth: 2.11,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.67 34.9799C27.8656 34.9799 35.32 27.5255 35.32 18.3299C35.32 9.13439 27.8656 1.67993 18.67 1.67993C9.47448 1.67993 2.02002 9.13439 2.02002 18.3299C2.02002 27.5255 9.47448 34.9799 18.67 34.9799Z",
    stroke: "#000000d9",
    strokeWidth: 2.11,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonalDetailsWhiteBackground);
export default __webpack_public_path__ + "static/media/personal-details-white-background.0bd14791c82e23a66ba133955cc7b90a.svg";
export { ForwardRef as ReactComponent };